import React, { useContext } from 'react';
import ErrorHandler from '../../clients/error-handler';
import { UserContextFragment } from '../../generated/graphqlv2';

interface IGlobalContext {
    isLoggedIn: boolean;
    setIsLoggedIn: (isLoggedIn: boolean) => void;
    user: UserContextFragment | null;
    setUser: (user: UserContextFragment | null) => void;
    errorHandler: ErrorHandler;
}

const GlobalContext = React.createContext<IGlobalContext>({} as IGlobalContext);
const GlobalContextProvider: React.FC<{
    errorHandler: ErrorHandler;
}> = ({ errorHandler, children }) => {
    const [user, setUser] = React.useState<UserContextFragment | null>(null);
    const [isLoggedIn, setIsLoggedIn] = React.useState(false);

    return (
        <GlobalContext.Provider
            value={{
                isLoggedIn,
                setIsLoggedIn,
                user,
                setUser,
                errorHandler,
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
};

const useGlobalContext = () => useContext(GlobalContext);

export { GlobalContext, GlobalContextProvider, useGlobalContext };
